import * as types from "../actionConstants";

export const toggleAction = { type: types.TOGGLE_SIDEBAR };

export const playTransitionAction = (isLoaded: Boolean) => ({
  type: types.LOAD_PAGE,
  payload: isLoaded
});
